export default [
  {
    name: "Driver’s License Number",
    state: "Driver’s License",
    id: "1"
  },
  {
    name: "State ID Number",
    state: "State ID",
    id: "2"
  },
  {
    name: "Passport Number",
    state: "",
    id: "3"
  }
];
